<template>
  <div class="dashboard-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs-container">
      <el-tab-pane label="全部场所" name="all"></el-tab-pane>
      <el-tab-pane label="出租屋" name="czw"></el-tab-pane>
      <el-tab-pane label="三小" name="sx"></el-tab-pane>
      <el-tab-pane label="其他" name="other"></el-tab-pane>
    </el-tabs>

    <!-- 项目基本信息 -->
    <el-card class="info-summary-card section-card" shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">项目基本信息</span>
      </div>
      <div class="card-content">
        <!-- 项目基本信息第一行 -->
        <div class="project-info-row">
          <el-row :gutter="12">
            <el-col :span="12">
              <div class="info-item-inline">
                <span class="info-label">项目ID：</span>
                <span class="info-value">{{ project_id }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item-inline project-name-item">
                <span class="info-label">项目名称：</span>
                <span class="info-value project-name-value" :title="project_name">{{ project_name }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 项目统计数据第二行 -->
        <div class="project-stats-row">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="stat-item primary-stat">
                <div class="stat-label">场所总数量</div>
                <div class="stat-value">{{ site_number }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="stat-item secondary-stat">
                <div class="stat-label">项目人数</div>
                <div class="stat-value">{{ total_employees }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>

    <!-- 昨日检测情况 -->
    <el-card class="daily-card section-card" shadow="never">
      <div slot="header" class="card-header daily-header">
        <span class="card-title">昨日检测情况</span>
      </div>
      <div class="card-content">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat-item daily-stat">
              <div class="stat-label">已完成检测数量</div>
              <div class="stat-value">{{ today_ywc_count }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-item daily-stat">
              <div class="stat-label">已完成复检数量</div>
              <div class="stat-value">{{ today_ywc_fj_count }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-item daily-stat">
              <div class="stat-label">CMA版隐患总数量</div>
              <div class="stat-value">{{ today_cma_count }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-item daily-stat">
              <div class="stat-label">直观版隐患总数量</div>
              <div class="stat-value">{{ today_zg_count }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 总体检测情况 -->
    <el-card class="detection-card section-card" shadow="never">
      <div slot="header" class="card-header detection-header">
        <span class="card-title">总体检测情况</span>
      </div>
      <div class="card-content">
        <el-row :gutter="20">
          <el-col :span="5">
            <div class="stat-item detection-stat">
              <div class="stat-label">已完成复检数量</div>
              <div class="stat-value">{{ summary_ywc_fj_count }}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item detection-stat">
              <div class="stat-label">已完成检测数量</div>
              <div class="stat-value">{{ summary_ywc_count }}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item detection-stat">
              <div class="stat-label">检测中数量</div>
              <div class="stat-value">{{ summary_jcz_count }}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item detection-stat">
              <div class="stat-label">无检测数量</div>
              <div class="stat-value">{{ summary_wjc_count }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item detection-stat completion-stat">
              <div class="stat-label">完成率</div>
              <div class="stat-value">{{ summary_completion_rate }}%</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 隐患统计 -->
    <el-card class="hazard-card section-card" shadow="never">
      <div slot="header" class="card-header hazard-header">
        <span class="card-title">隐患统计</span>
        <!-- <el-button type="text" size="small" @click="showRectificationDialog" class="view-details-btn">
          <i class="el-icon-view"></i> 查看详情
        </el-button> -->
      </div>
      <div class="card-content">
        <!-- 总体统计 - 顶部显示 -->
        <div class="overall-stats-section">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="stat-item overall-stat">
                <div class="stat-label">总问题数</div>
                <div class="stat-value">{{ project_total_count }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item overall-stat">
                <div class="stat-label">已整改数</div>
                <div class="stat-value">{{ project_rectified_count }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item overall-stat">
                <div class="stat-label">整改率</div>
                <div class="stat-value">{{ project_overall_rate }}%</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 分隔线 -->
        <div class="section-divider"></div>

        <!-- 隐患详细统计表格 -->
        <el-row :gutter="24">
          <!-- CMA版隐患表格 -->
          <el-col :span="12">
            <div class="hazard-section">
              <h4 class="hazard-section-title">CMA版隐患</h4>
              <!-- CMA版隐患表格 -->
              <el-table :data="cmaHazardData" border size="small" :header-cell-style="{
                backgroundColor: '#2563eb',
                color: 'white',
                fontWeight: '600',
                textAlign: 'center'
              }" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="level" label="级别" width="80" align="center">
                  <template v-slot="scope">
                    <el-tag :type="getLevelTagType(scope.row.level)" size="small">{{ scope.row.level }}级</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="total" label="总数" align="center"></el-table-column>
                <el-table-column prop="rectified" label="已整改" align="center"></el-table-column>
                <el-table-column prop="rate" label="整改率" align="center">
                  <template v-slot="scope">
                    <span :class="getRateClass(scope.row.rate)">{{ scope.row.rate }}%</span>
                  </template>
                </el-table-column>
              </el-table>

              <!-- CMA版汇总统计 -->
              <div class="summary-stats">
                <el-row :gutter="16">
                  <el-col :span="12">
                    <div class="stat-item compact-stat summary-item">
                      <div class="stat-label">CMA版总数/已整改</div>
                      <div class="stat-value">
                        <span class="primary-value">{{ summary_cma_count }}</span>
                        <span class="divider-slash">/</span>
                        <span class="secondary-value">{{ rectificationStats ? rectificationStats.cma_rectified_count : 0
                          }}</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="stat-item compact-stat summary-item">
                      <div class="stat-label">CMA版整改率</div>
                      <div class="stat-value">{{ getCmaRectificationRate() }}%</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>

          <!-- 直观版隐患表格 -->
          <el-col :span="12">
            <div class="hazard-section">
              <h4 class="hazard-section-title">直观版隐患</h4>
              <!-- 直观版隐患表格 -->
              <el-table :data="zgHazardData" border size="small" :header-cell-style="{
                backgroundColor: '#2563eb',
                color: 'white',
                fontWeight: '600',
                textAlign: 'center'
              }" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="level" label="级别" width="80" align="center">
                  <template v-slot="scope">
                    <el-tag :type="getLevelTagType(scope.row.level)" size="small">{{ scope.row.level }}级</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="total" label="总数" align="center"></el-table-column>
                <el-table-column prop="rectified" label="已整改" align="center"></el-table-column>
                <el-table-column prop="rate" label="整改率" align="center">
                  <template v-slot="scope">
                    <span :class="getRateClass(scope.row.rate)">{{ scope.row.rate }}%</span>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 直观版汇总统计 -->
              <div class="summary-stats">
                <el-row :gutter="16">
                  <el-col :span="12">
                    <div class="stat-item compact-stat summary-item">
                      <div class="stat-label">直观版总数/已整改</div>
                      <div class="stat-value">
                        <span class="primary-value">{{ summary_zg_count }}</span>
                        <span class="divider-slash">/</span>
                        <span class="secondary-value">{{ rectificationStats ? rectificationStats.zg_rectified_count : 0
                          }}</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="stat-item compact-stat summary-item">
                      <div class="stat-label">直观版整改率</div>
                      <div class="stat-value">{{ getZgRectificationRate() }}%</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 图表区域 -->
    <el-card class="chart-card section-card" shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">隐患分布图表</span>
      </div>
      <div class="card-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="chart-wrapper">
              <h4 class="chart-title">CMA隐患分布</h4>
              <div class="chart-container">
                <div id="myChart1" style="height:100%;"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="chart-wrapper">
              <h4 class="chart-title">直观隐患分布</h4>
              <div class="chart-container">
                <div id="myChart" style="height:100%;"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 导入模板下载 -->
    <el-card class="download-card section-card" shadow="never">
      <div slot="header" class="card-header download-header">
        <span class="card-title">导入模板下载</span>
      </div>
      <div class="card-content">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="download-item">
              <el-link href="https://dq-back.wzfire.com/site_model/site_czws.xlsx" type="primary" class="download-link">
                <i class="el-icon-download"></i>
                <span>出租屋台账导入模板</span>
              </el-link>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="download-item">
              <el-link href="https://dq-back.wzfire.com/site_model/site_sxs.xlsx" type="primary" class="download-link">
                <i class="el-icon-download"></i>
                <span>三小场所导入模板</span>
              </el-link>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="download-item">
              <el-link href="https://dq-back.wzfire.com/site_model/site_others.xlsx" type="primary"
                class="download-link">
                <i class="el-icon-download"></i>
                <span>其他场所导入模板</span>
              </el-link>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      project_name: '',
      total_employees: '',
      site_amount_number: 0,
      today_site_number: 0,
      site_status_wks_number: 0,
      site_status_jcz_number: 0,
      site_status_ywc_number: 0,
      site_status_sptg_number: 0,
      trouble_all_number: 0,
      trouble_zg_number: 0,
      trouble_cma_number: 0,

      today_ywc_count: 0,
      today_ywc_fj_count: 0,
      today_cma_count: 0,
      today_zg_count: 0,

      summary_ywc_count: 0,
      summary_ywc_fj_count: 0,
      summary_wks_count: 0,
      summary_jcz_count: 0,
      summary_wjc_count: 0,
      summary_completion_rate: 0,
      summary_cma_count: 0,
      summary_cma_wzg_count: 0,
      summary_cma_a_count: 0,
      summary_cma_a_wzg_count: 0,
      summary_cma_b_count: 0,
      summary_cma_b_wzg_count: 0,
      summary_cma_c_count: 0,
      summary_cma_c_wzg_count: 0,
      summary_zg_count: 0,
      summary_zg_wzg_count: 0,
      summary_zg_a_count: 0,
      summary_zg_a_wzg_count: 0,
      summary_zg_b_count: 0,
      summary_zg_b_wzg_count: 0,
      summary_zg_c_count: 0,
      summary_zg_c_wzg_count: 0,
      site_type: '',
      site_number: 0,
      chart: null,
      activeTab: 'all',
      // 新增整改率相关数据
      rectificationStats: null,
      project_total_count: 0,
      project_rectified_count: 0,
      project_overall_rate: '0.00',
      project_zg_total_count: 0,
      project_zg_rectified_count: 0,
      project_zg_overall_rate: '0.00',
      project_zg_a_rectified: 0,
      project_zg_b_rectified: 0,
      project_zg_c_rectified: 0,
      project_cma_total_count: 0,
      project_cma_rectified_count: 0,
      project_cma_overall_rate: '0.00',
      project_cma_a_rectified: 0,
      project_cma_b_rectified: 0,
      project_cma_c_rectified: 0,
      project_level_a_total: 0,
      project_level_a_rectified: 0,
      project_level_a_rate: '0.00',
      project_level_b_total: 0,
      project_level_b_rectified: 0,
      project_level_b_rate: '0.00',
      project_level_c_total: 0,

      // 对话框相关
      rectificationDialogVisible: false,
      rectificationLevelData: []
    }
  },
  methods: {

    // 计算CMA版整改率
    getCmaRectificationRate() {
      if (!this.rectificationStats || this.summary_cma_count === 0) {
        return '0.00';
      }
      const rate = (this.rectificationStats.cma_rectified_count / this.summary_cma_count * 100).toFixed(2);
      return rate;
    },

    // 计算直观版整改率
    getZgRectificationRate() {
      if (!this.rectificationStats || this.summary_zg_count === 0) {
        return '0.00';
      }
      const rate = (this.rectificationStats.zg_rectified_count / this.summary_zg_count * 100).toFixed(2);
      return rate;
    },

    handleTabClick(tab) {
      this.activeTab = tab.name;
      this.loadDataBasedOnTab(this.activeTab);
    },
    async loadDataBasedOnTab(tabName) {
      await this.getProject(tabName)
      await this.getToday(tabName)
      await this.getTrouble(tabName)
    },
    //获取项目信息（项目名称，人员数量，场所类型）
    async getProject(type) {
      try {
        let res = await this.$Api.post("get_project_info", { project_id: this.project_id })
        if (res) {
          this.project_name = res.project_name
          this.total_employees = res.total_employees
          if (type === 'czw') {
            this.site_number = res.czw_number;
          } else if (type === 'sx') {
            this.site_number = res.sx_number;
          } else if (type === 'other') {
            this.site_number = res.other_number
          } else {
            this.site_number = res.czw_number + res.sx_number + res.other_number;
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //今日检测情况
    async getToday(site_type) {
      try {
        let res = await this.$Api.post('get_today_info', { project_id: this.project_id, site_type: site_type })
        if (res) {
          this.today_ywc_count = res.today_ywc_count
          this.today_ywc_fj_count = res.today_ywc_fj_count
          this.today_cma_count = res.today_cma_count
          this.today_zg_count = res.today_zg_count
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取隐患数量
    async getTrouble(site_type) {
      try {
        let res = await this.$Api.post("get_process_trouble", { project_id: this.project_id, site_type: site_type })
        if (res) {
          this.trouble_all_number = res.trouble_all_number
          this.trouble_zg_number = res.trouble_zg_number
          this.trouble_cma_number = res.trouble_cma_number
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async updateDataAndCharts() {
      //直观隐患数量
      let zg_data = [];
      let cma_data = [];
      //总体检测情况
      let res = await this.$Api.post('get_summary_info', { project_id: this.project_id, site_type: this.activeTab })
      if (res) {
        this.summary_ywc_count = res.summary_ywc_count
        this.summary_ywc_fj_count = res.summary_ywc_fj_count
        this.summary_wks_count = res.summary_wks_count
        this.summary_jcz_count = res.summary_jcz_count
        this.summary_wjc_count = res.summary_wjc_count
        this.summary_completion_rate = res.summary_completion_rate
        this.summary_cma_count = res.summary_cma_count
        this.summary_cma_wzg_count = res.summary_cma_wzg_count
        this.summary_cma_a_count = res.summary_cma_a_count
        this.summary_cma_a_wzg_count = res.summary_cma_a_wzg_count
        this.summary_cma_b_count = res.summary_cma_b_count
        this.summary_cma_b_wzg_count = res.summary_cma_b_wzg_count
        this.summary_cma_c_count = res.summary_cma_c_count
        this.summary_cma_c_wzg_count = res.summary_cma_c_wzg_count
        this.summary_zg_count = res.summary_zg_count
        this.summary_zg_wzg_count = res.summary_zg_wzg_count
        this.summary_zg_a_count = res.summary_zg_a_count
        this.summary_zg_a_wzg_count = res.summary_zg_a_wzg_count
        this.summary_zg_b_count = res.summary_zg_b_count
        this.summary_zg_b_wzg_count = res.summary_zg_b_wzg_count
        this.summary_zg_c_count = res.summary_zg_c_count
        this.summary_zg_c_wzg_count = res.summary_zg_c_wzg_count
        // 新增整改率数据处理
        this.rectificationStats = res.rectification_stats;
        this.project_total_count = res.project_cma_total_count + res.project_zg_total_count;
        this.project_rectified_count = res.project_rectified_count;
        this.project_overall_rate = res.project_overall_rate;
        this.project_zg_total_count = res.project_zg_total_count;
        this.project_zg_rectified_count = res.project_zg_rectified_count;
        this.project_zg_overall_rate = res.project_zg_overall_rate;
        this.project_zg_a_rectified = res.project_zg_a_rectified;
        this.project_zg_b_rectified = res.project_zg_b_rectified;
        this.project_zg_c_rectified = res.project_zg_c_rectified;
        this.project_cma_total_count = res.project_cma_total_count;
        this.project_cma_rectified_count = res.project_cma_rectified_count;
        this.project_cma_overall_rate = res.project_cma_overall_rate;
        this.project_cma_a_rectified = res.project_cma_a_rectified;
        this.project_cma_b_rectified = res.project_cma_b_rectified;
        this.project_cma_c_rectified = res.project_cma_c_rectified;
        this.project_level_a_total = res.project_level_a_total;
        this.project_level_a_rectified = res.project_level_a_rectified;
        this.project_level_a_rate = res.project_level_a_rate;
        this.project_level_b_total = res.project_level_b_total;
        this.project_level_b_rectified = res.project_level_b_rectified;
        this.project_level_b_rate = res.project_level_b_rate;
        this.project_level_c_total = res.project_level_c_total;
        this.project_level_c_rectified = res.project_level_c_rectified;
        this.project_level_c_rate = res.project_level_c_rate;

        zg_data.push({ value: res.summary_zg_a_count, name: 'A' })
        zg_data.push({ value: res.summary_zg_b_count, name: 'B' })
        zg_data.push({ value: res.summary_zg_c_count, name: 'C' })
        cma_data.push({ value: res.summary_cma_a_count, name: 'A' })
        cma_data.push({ value: res.summary_cma_b_count, name: 'B' })
        cma_data.push({ value: res.summary_cma_c_count, name: 'C' })
      }
      // 直观
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      let option = {
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'center'
        },
        series: [
          {
            name: '隐患数量',
            type: 'pie',
            radius: '50%',
            data: zg_data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      //cma
      let myChart1 = this.$echarts.init(document.getElementById('myChart1'))
      // 绘制图表
      let option1 = {
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'center'
        },
        series: [
          {
            name: 'CMA隐患',
            type: 'pie',
            radius: '50%',
            data: cma_data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart1.setOption(option1);
    },
    // 显示整改详情对话框
    showRectificationDialog() {
      this.prepareRectificationLevelData();
      this.rectificationDialogVisible = true;
    },

    // 准备级别数据
    prepareRectificationLevelData() {
      if (this.rectificationStats) {
        this.rectificationLevelData = [
          {
            level: 'A',
            total: this.project_level_a_total,
            rectified: this.project_level_a_rectified,
            rate: this.project_level_a_rate
          },
          {
            level: 'B',
            total: this.project_level_b_total,
            rectified: this.project_level_b_rectified,
            rate: this.project_level_b_rate
          },
          {
            level: 'C',
            total: this.project_level_c_total,
            rectified: this.project_level_c_rectified,
            rate: this.project_level_c_rate
          }
        ];
      }
    },

    // 获取级别标签类型
    getLevelTagType(level) {
      const typeMap = {
        'A': 'danger',
        'B': 'warning',
        'C': 'info'
      };
      return typeMap[level] || 'info';
    },

    // 获取整改率样式类
    getRateClass(rate) {
      const rateNum = parseFloat(rate);
      if (rateNum >= 80) return 'rate-high';
      if (rateNum >= 50) return 'rate-medium';
      return 'rate-low';
    }
  },
  watch: {
    activeTab() {
      this.updateDataAndCharts();
    }
  },
  computed: {
    // CMA版隐患表格数据
    cmaHazardData() {
      return [
        {
          level: 'A',
          total: this.summary_cma_a_count,
          rectified: this.project_cma_a_rectified,
          rate: this.summary_cma_a_count > 0 ? ((this.project_cma_a_rectified / this.summary_cma_a_count) * 100).toFixed(2) : '0.00'
        },
        {
          level: 'B',
          total: this.summary_cma_b_count,
          rectified: this.project_cma_b_rectified,
          rate: this.summary_cma_b_count > 0 ? ((this.project_cma_b_rectified / this.summary_cma_b_count) * 100).toFixed(2) : '0.00'
        },
        {
          level: 'C',
          total: this.summary_cma_c_count,
          rectified: this.project_cma_c_rectified,
          rate: this.summary_cma_c_count > 0 ? ((this.project_cma_c_rectified / this.summary_cma_c_count) * 100).toFixed(2) : '0.00'
        }
      ];
    },

    // 直观版隐患表格数据
    zgHazardData() {
      return [
        {
          level: 'A',
          total: this.summary_zg_a_count,
          rectified: this.project_zg_a_rectified,
          rate: this.summary_zg_a_count > 0 ? ((this.project_zg_a_rectified / this.summary_zg_a_count) * 100).toFixed(2) : '0.00'
        },
        {
          level: 'B',
          total: this.summary_zg_b_count,
          rectified: this.project_zg_b_rectified,
          rate: this.summary_zg_b_count > 0 ? ((this.project_zg_b_rectified / this.summary_zg_b_count) * 100).toFixed(2) : '0.00'
        },
        {
          level: 'C',
          total: this.summary_zg_c_count,
          rectified: this.project_zg_c_rectified,
          rate: this.summary_zg_c_count > 0 ? ((this.project_zg_c_rectified / this.summary_zg_c_count) * 100).toFixed(2) : '0.00'
        }
      ];
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.loadDataBasedOnTab(this.activeTab)
  },
  mounted() {
    this.updateDataAndCharts();
  },
};
</script>

<style scoped>
:root {
  --primary-color: #1890ff;
  --primary-light: #e6f7ff;
  --primary-dark: #096dd9;
  --success-color: #52c41a;
  --warning-color: #faad14;
  --danger-color: #ff4d4f;
  --text-primary: #262626;
  --text-secondary: #595959;
  --text-disabled: #bfbfbf;

  /* 功能区域颜色变量 */
  --daily-color: #ff6b35;
  --summary-color: #4ecdc4;
  --rectification-color: #6b46c1;
  --hazard-color: #2563eb;
}

.dashboard-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding: 24px;
  background: #f5f5f5;
  min-height: 100vh;
}

/* Tab容器样式 */
.tabs-container {
  margin-bottom: 24px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

:deep(.el-tabs__header) {
  margin: 0;
  background: white;
}

:deep(.el-tabs__nav-wrap::after) {
  display: none;
}

:deep(.el-tabs__item) {
  padding: 0 32px;
  height: 56px;
  line-height: 56px;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-secondary);
  transition: all 0.3s;
  border: none;
  background: white;
}

:deep(.el-tabs__item:nth-child(1).is-active) {
  color: var(--primary-color);
}

:deep(.el-tabs__item:nth-child(2).is-active) {
  color: var(--daily-color);
}

:deep(.el-tabs__item:nth-child(3).is-active) {
  color: var(--summary-color);
}

:deep(.el-tabs__item:nth-child(4).is-active) {
  color: var(--hazard-color);
}

:deep(.el-tabs__item:hover) {
  color: var(--primary-color);
  background: #f8f9fa;
}

:deep(.el-tabs__active-bar) {
  height: 3px;
}

/* 统一的卡片样式 */
.section-card {
  margin-bottom: 24px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: none;
  overflow: hidden;
}

.section-card:last-child {
  margin-bottom: 0;
}

.card-header {
  background: linear-gradient(135deg, var(--primary-light), #f0f9ff);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-weight: 600;
  font-size: 18px;
  color: var(--primary-dark);
}

.card-content {
  padding: 24px;
}

/* 不同卡片的header颜色 */
.daily-header {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.daily-header .card-title {
  color: var(--daily-color);
}

.detection-header {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.detection-header .card-title {
  color: var(--summary-color);
}

.rectification-header {
  background: linear-gradient(135deg, #d299c2 0%, #fef9d7 100%);
}

.rectification-header .card-title {
  color: var(--rectification-color);
}

.hazard-header {
  background: linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%);
}

.hazard-header .card-title {
  color: var(--hazard-color);
}

.download-header {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.download-header .card-title {
  color: #7c2d12;
}

/* 项目信息样式 */
.project-info-row {
  padding: 6px 0;
  margin-bottom: 12px;
}

.project-stats-row {
  padding: 0;
}

.info-item-inline {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 10px;
  background: transparent;
  border-radius: 4px;
  transition: all 0.2s;
  min-height: 32px;
}

.info-item-inline:hover {
  background: rgba(24, 144, 255, 0.05);
}

.info-item-inline .info-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
  min-width: fit-content;
}

.info-item-inline .info-value {
  font-size: 13px;
  font-weight: 600;
  margin-left: 3px;
  color: var(--primary-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 项目名称特殊处理 */
.project-name-item {
  justify-content: flex-start;
}

.project-name-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 70px);
  display: inline-block;
}

/* 数字类信息项目居中对齐 */
.info-item-inline:not(.project-name-item) {
  justify-content: center;
}

.secondary-stat {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border: none;
  height: 80px;
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.secondary-stat .stat-label,
.secondary-stat .stat-value {
  color: white;
}

.secondary-stat .stat-value {
  font-size: 24px;
  font-weight: 700;
}

.secondary-stat .stat-label {
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 500;
}

.secondary-stat:hover {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* 统计项样式 */
.stat-item {
  text-align: center;
  padding: 16px;
  border: 2px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.3s ease;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.stat-item:hover {
  border-color: var(--primary-color);
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 4px;
  font-weight: 500;
  line-height: 1.2;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.stat-detail {
  font-size: 12px;
  margin-top: 4px;
  color: var(--text-secondary);
  font-weight: 500;
  line-height: 1.2;
}

/* 不同类型统计项的颜色 */
.daily-stat .stat-label {
  color: var(--daily-color);
}

.daily-stat .stat-value {
  color: var(--daily-color);
}

.detection-stat .stat-label {
  color: var(--summary-color);
}

.detection-stat .stat-value {
  color: var(--summary-color);
}

.completion-stat .stat-value {
  color: var(--success-color);
}

.rectification-stat .stat-label {
  color: var(--rectification-color);
}

.rectification-stat .stat-value {
  color: var(--rectification-color);
}

.hazard-stat .stat-label {
  color: var(--hazard-color);
}

.hazard-stat .stat-value {
  color: var(--hazard-color);
}

/* 总体统计区域样式 */
.overall-stats-section {
  margin-bottom: 24px;
}

.overall-stat {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  height: 70px;
  padding: 12px;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.overall-stat .stat-label {
  color: #ffffff !important;
  font-size: 13px;
  margin-bottom: 4px;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.overall-stat .stat-value {
  color: #ffffff !important;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.overall-stat .stat-detail {
  color: #f0f0f0 !important;
  font-size: 12px;
  margin-top: 4px;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.overall-stat:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* 分隔线样式 */
.section-divider {
  height: 1px;
  background: linear-gradient(to right, transparent, #e2e8f0, transparent);
  margin-bottom: 24px;
  position: relative;
}

.section-divider::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -3px;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  background: var(--hazard-color);
  border-radius: 50%;
}

/* 隐患统计样式 */
.hazard-section {
  margin-bottom: 0;
  padding: 0 12px;
}

.hazard-section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--hazard-color);
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--hazard-color);
  display: inline-block;
  text-align: center;
  width: 100%;
}

/* 项目统计数据样式修复 */
.primary-stat {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  height: 80px;
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.primary-stat .stat-label {
  color: #ffffff !important;
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.primary-stat .stat-value {
  color: #ffffff !important;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.primary-stat:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.secondary-stat {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border: none;
  height: 80px;
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.3);
}

.secondary-stat .stat-label {
  color: #ffffff !important;
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.secondary-stat .stat-value {
  color: #ffffff !important;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.secondary-stat:hover {
  background: linear-gradient(135deg, #e879f9 0%, #ef4444 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(240, 147, 251, 0.4);
}

/* 汇总统计样式 */
.summary-stats {
  margin-top: 12px;
}

.summary-item {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #dee2e6;
  height: 50px;
}

.summary-item:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-color: var(--hazard-color);
}

.summary-item .stat-label {
  color: var(--hazard-color);
  font-weight: 600;
  font-size: 10px;
}

.summary-item .stat-value {
  font-size: 16px;
}

/* 紧凑版统计项 */
.compact-stat {
  height: 60px;
  padding: 12px;
}

.compact-stat .stat-label {
  font-size: 11px;
  margin-bottom: 2px;
}

.compact-stat .stat-value {
  font-size: 18px;
}

.detail-stat.compact-stat .stat-value {
  font-size: 16px;
}

.primary-value {
  color: var(--primary-color);
}

.secondary-value {
  color: var(--success-color);
}

.divider-slash {
  margin: 0 4px;
  color: var(--text-disabled);
  font-weight: 400;
}

/* 图表样式 */
.chart-wrapper {
  text-align: center;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-dark);
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--primary-light);
  display: inline-block;
}

.chart-container {
  height: 400px;
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
}

/* 下载区域样式 */
.download-item {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  border-radius: 12px;
  transition: all 0.3s;
}

.download-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.download-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white !important;
  text-decoration: none;
  font-weight: 600;
}

.download-link i {
  font-size: 24px;
  margin-bottom: 8px;
}

/* 整改详情对话框样式 */
.rectification-detail-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.rectification-detail-card:last-child {
  margin-bottom: 0;
}

.rectification-detail-card .stat-item {
  height: auto;
  min-height: 100px;
}

.highlight {
  color: var(--primary-color);
}

.type-stats {
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  padding: 20px;
  background: #fafafa;
}

.type-stats h4 {
  margin: 0 0 16px 0;
  color: var(--text-primary);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}

.mini-stat {
  text-align: center;
  padding: 12px;
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.mini-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mini-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 4px;
  font-weight: 500;
}

.mini-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.rate-high {
  color: var(--success-color);
  font-weight: 700;
}

.rate-medium {
  color: var(--warning-color);
  font-weight: 700;
}

.rate-low {
  color: var(--danger-color);
  font-weight: 700;
}

/* 工具类 */
.mb-16 {
  margin-bottom: 16px;
}

/* 防止el-col样式被覆盖 */
:deep(.el-col) {
  background: transparent !important;
  transition: none !important;
  border: none !important;
  box-shadow: none !important;
}

:deep(.el-col):hover {
  background: transparent !important;
  transform: none !important;
  border: none !important;
  box-shadow: none !important;
}

:deep(.el-row) {
  background: transparent !important;
  transition: none !important;
}

:deep(.el-row):hover {
  background: transparent !important;
  transform: none !important;
}

/* Element UI 深度样式覆盖 */
:deep(.el-card) {
  border: none;
}

:deep(.el-card__header) {
  padding: 0;
  border-bottom: none;
}

:deep(.el-dialog) {
  border-radius: 16px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  background: linear-gradient(135deg, var(--primary-light), #f0f9ff);
  padding: 20px 24px;
}

:deep(.el-dialog__title) {
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-dark);
}

/* 只对对话框中的表格应用样式，不影响隐患统计中的表格 */
:deep(.el-dialog .el-table) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.el-dialog .el-table th) {
  background: var(--primary-light);
  color: var(--primary-dark);
  font-weight: 600;
}
</style>